module.exports = __webpack_public_path__ + "img/www.healthgrades.com.157f86af.png";